import { Checkbox, DateInput, Field, TextOutput } from 'Components/Core';
import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { hasValue, valueOrDefault } from 'Lib/Any';
import { Guid } from 'Lib/Guid';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { pipe } from 'rxjs';
import * as oPath from '../../../../../Lib/Object/Path/Immutable';
import { NamePrefixModifier, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from '../../../../Layout';

let defaultDaysRange = 30;

const Section: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const sampledDate = useSelector((s) => {
    return oPath.get(s, `worksheetEditor.syncModel.header.Sample.DateTimeSampled`);
  });
  const importedDate = useSelector(createWorksheetSelector!('Retest.OriginalTest.ImportedTest.Sample.DateTimeSampled'));
  const importedOriginalTestId = useSelector(createWorksheetSelector!('Retest.OriginalTestId')) as Guid;
  const defaultEndDate = moment(sampledDate ?? undefined);
  const defaultStartDate = moment.min([moment(importedDate), moment(defaultEndDate).subtract(defaultDaysRange, 'd')]);
  const [startDateSelected, setStartDate] = useState<string>(defaultStartDate.format('YYYY-MM-DD'));
  const [endDateSelected, setEndDate] = useState<string>(defaultEndDate.format('YYYY-MM-DD'));
  const startDateChanged = ({ data: { value } }: { data: { value: string } }) => {
    setStartDate(value);
  };
  const endDateChanged = ({ data: { value } }: { data: { value: string } }) => {
    setEndDate(value);
  };
  var isRetest = useSelector(pipe(createWorksheetSelector!('Retest.IsRetest'), valueOrDefault(false)));
  var hasSelectedOriginalTest = useSelector(
    pipe(createWorksheetSelector!('Retest.OriginalTest.ImportedTest.Id'), hasValue)
  );
  return (
    <PageSection heading="Retest">
      <ListFieldSection>
        <Field
          input={<Checkbox />}
          label="Retest of Failing Test"
          name="Retest.IsRetest"
          confirm={hasSelectedOriginalTest}
        />
      </ListFieldSection>
      {isRetest && (
        <WorksheetAssociatedTestSection
          label="Previous failing test"
          name="Retest.OriginalTest"
          testType="Nuclear Field Density"
          associatedTestModel={{
            imported: {
              testSearchLabel: 'Previous Failing Test',
              emptyListMessage: 'No failing tests found in the selected date range, consider looking back further.',
              importPropertyName: 'OriginalTest',
              queryParams: {
                startTestDate: startDateSelected,
                endTestDate: endDateSelected,
              },
              importModel: { Id: importedOriginalTestId },
              selectionFields: (
                <ListFieldSection heading="Find failing tests between">
                  <Field
                    input={<DateInput />}
                    label="Start Date"
                    onChange={startDateChanged}
                    defaultValue={startDateSelected}
                  />
                  <Field
                    input={<DateInput />}
                    label="End Date"
                    onChange={endDateChanged}
                    defaultValue={endDateSelected}
                  />
                </ListFieldSection>
              ),
              importedTestResults: (
                <ListFieldSection>
                  <NamePrefixModifier appendNamePrefix="Retest.OriginalTest.ImportedTest.Results">
                    <Field input={<TextOutput />} label="Specification" name="Specification" />
                    <Field input={<TextOutput />} label="Location" name="Location" />
                    <Field input={<TextOutput />} label="Relative Compaction (%)" name="RelativeCompaction" />
                    <Field input={<TextOutput />} label="Air Voids (%)" name="AirVoids" />
                  </NamePrefixModifier>
                </ListFieldSection>
              ),
            },
          }}
        />
      )}
    </PageSection>
  );
};

const BsRetestSection = withInjectedProps(Section);

export { BsRetestSection };
export default BsRetestSection;
